export const initialSelectedNumeriNeri = {
  data: {
    id: "",
    numero: "",
    intervallo: "",
    maxActiveCallsInfos: [],
  },
  loading: false,
};
